<template>
  <div class="view-container">
        <modal :showDialog="(activeModal == ActiveModal.AddEdit)" @close="closeModal" :title="selectedElement == null ? $t('AddVisit') : $t('EditVisit')">
            <visit-modal @saved="modalFinished" :existingObject="selectedElement"/>
        </modal>
        <modal :showDialog="(activeModal == ActiveModal.ConfirmBox)" @close="closeModal" >
            <info-confirm :text="confirmBoxText" @confirm="closeModal"/>
        </modal>
        <div style="width: 100%; height: 100%; overflow-x: auto">
		    <div class="max-grid">
				<ejs-grid ref="grid" height='100%' width='100%' :toolbar='toolbar' :toolbarClick='toolbarClick' :selectionSettings='selectionOptions' :allowTextWrap="true" :textWrapSettings='wrapSettings' :dataBound='dataBound' :dataSource="data" :allowPaging="true" :pageSettings='pageSettings' :allowFiltering='true' :filterSettings='filterOptions' :allowSorting='true' :allowMultiSorting='true' :allowPdfExport='true' :allowCsvExport='true' :allowExcelExport='true' :showBusyIndicator="true">
					<e-columns>
						<e-column v-if="systemId == null" field='farmName' :headerText="$t('FarmName')" textAlign='Left' :customAttributes="customAttributes" :filter="filterCheckBox"></e-column>
						<e-column width="200" field='statusText' :headerText="$t('Status')" textAlign='Left' :customAttributes="customAttributes" :filter="filterCheckBox"></e-column>
						<e-column field='mainAssigneeName' :headerText="$t('Assignee')" textAlign='Left' :customAttributes="customAttributes" :filter="filterCheckBox"></e-column>
						<e-column field='dateFrom' :headerText="$t('DateFrom')" textAlign='Left' type="datetime" :format="dateTimeFormatOptions" :customAttributes="customAttributes"></e-column>
						<e-column field='dateTo' :headerText="$t('DateTo')" textAlign='Left' type="datetime" :format="dateTimeFormatOptions" :customAttributes="customAttributes"></e-column>
						<e-column field='started' :headerText="$t('Started')" textAlign='Left' type="datetime" :format="dateTimeFormatOptions" :customAttributes="customAttributes"></e-column>
						<e-column field='ended' :headerText="$t('Ended')" textAlign='Left' type="datetime" :format="dateTimeFormatOptions" :customAttributes="customAttributes"></e-column>
						<e-column :headerText="''" :template="ButtonsTemplate" :allowFiltering="false" :allowSorting="false" :customAttributes="customAttributes" width="100px"></e-column>
					</e-columns>
				</ejs-grid>
			</div>
		</div>
    </div>
</template>

<script>
import { Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport } from '@syncfusion/ej2-vue-grids';
import { getVisits, getVisitsForSystemById } from '@/api/api';
import VisitModal from '@/components/Visits/VisitModal.vue';
import { VisitModels } from '@/Models/visitModels';
import { VisitsActiveModal } from '@/Models/VisitsActiveModal'
import Modal from '@/components/Modal.vue';
import VisitTableButtonsVue from '../../components/Visits/VisitTableButtons.vue';
import InfoConfirm from '@/components/InfoConfirm.vue';import { getReportForFinishedVisit } from '../../api/api';
import moment from 'moment';

var context = null;

export default {
    components: {
        VisitModal,
        Modal,
        InfoConfirm
    },
    provide: {
        grid: [Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport]
    },
    props: {
        systemId: {
            type: String,
            default: null,
            require: false
        },
        systemName: {
            type: String,
            default: null,
            require: false
        }
    },
    data() {
        return {
            visits: [],
            last_mode: VisitModels.All,
            data: [],
            ActiveModal: {},
            activeModal: null,
            selectedElement: null,
            pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
            toolbar: [
                { text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right', },
                // { text: this.$t('Excelexport'), prefixIcon: 'e-excelexport', align: 'Right', id: 'excel-export' },
                // { text: this.$t('Pdfexport'), prefixIcon: 'e-pdfexport', align: 'Right', id: 'pdf-export' },
                // { text: this.$t('Csvexport'), prefixIcon: 'e-csvexport', align: 'Right', id: 'csv-export' },
                { text: this.$t('AddVisit'), tooltipText: this.$t('AddVisit'), prefixIcon: 'e-add', id: 'addVisit', align: 'Right' },
				{ text: this.$t('EditVisit'), tooltipText: this.$t('EditVisit'), prefixIcon: 'e-edit', id: 'editVisit', align: 'Right'},
                'Search',
            ],
            wrapSettings: { wrapMode: "Content" },
            selectionOptions: { type: "Multiple" },
            filterOptions: {
                type: "Menu",
            },
            filterCheckBox: {
                type: "CheckBox",
            },
            customAttributes: { class: 'customcss' },
            dateTimeFormatOptions: { format: 'yyyy-MM-dd', type: 'dateTime' },
            confirmBoxText: "",
            ButtonsTemplate: function() {
				return {
					template: {
						extends: VisitTableButtonsVue,
						propsData: {
							show(data, mode){
								switch(mode){
									case 'SOLUTIONS':
                                        if(context.systemId != null) {
                                            this.$router.push({
                                                name: 'systemSolutionsForVisit',
                                                params: {
                                                    visitId: data.id,
                                                    systemId: context.systemId,
                                                    systemName: context.systemName
                                                },
                                            });
                                            break;
                                        }
                                        this.$router.push({
                                            name: 'visitsSolutionsForVisit',
                                            params: {
												visitId: data.id,
											},
                                        });
										break;
                                    case 'PENDING':
                                        if(context.systemId != null) {
                                            this.$router.push({
                                                name: 'settingsProblemsVisit',
                                                params: {
                                                    visitId: data.id,
                                                    systemId: context.systemId,
                                                    systemName: context.systemName,
                                                    visitMode: 'PENDING'
                                                },
                                            });
                                            break;
                                        }
                                        this.$router.push({
                                            name: 'visitsProblems',
                                            params: {
                                                visitId: data.id,
                                                visitMode: 'PENDING'
                                            }
                                        });
                                        break;
                                    case 'ACTIVE':
                                        if(context.systemId != null) {
                                            this.$router.push({
                                                name: 'settingsProblemsVisit',
                                                params: {
                                                    visitId: data.id,
                                                    systemId: context.systemId,
                                                    systemName: context.systemName,
                                                    visitMode: 'ACTIVE'
                                                },
                                            });
                                            break;
                                        }
                                        this.$router.push({
                                            name: 'visitsProblems',
                                            params: {
                                                visitId: data.id,
                                                visitMode: 'ACTIVE'
                                            }
                                        });
                                        break;
                                    case 'REPORT': 
                                        context.handleDownloadReport(data.id, `${data.farmName}_${moment(data.ended).format('YYYY-MM-DD')}`)
                                        break;
								}
							},

						}
					},
				};
			}
        }
    },
    methods: {
        async getData(mode) {
            if(mode == undefined){
                mode = this.last_mode
            }
            var result = []

            if(this.systemId != null) {
                result = await getVisitsForSystemById(this.systemId, mode)
            } else {
                result = await getVisits(mode)
            }

            result.forEach(r => {
                r.statusText = [this.$t('Pending'), this.$t('Active'), this.$t('Finished')][r.status]
            });

            var sortingWeights = {
                '0': 2,
                '1': 1,
                '2': 3
            }
            result.sort((a, b) => sortingWeights[a.status] - sortingWeights[b.status])

            this.last_mode = mode
            this.data = result
        },
        closeModal() {
            this.activeModal = this.ActiveModal.None
        },
        modalFinished() {
            this.closeModal();
            this.getData();
        },
        toolbarClick(args) {
            switch (args.item.id) {
                case "pdf-export":
                    this.$refs.grid.pdfExport();
                    break;
                case "csv-export":
                    this.$refs.grid.csvExport();
                    break;
                case "excel-export":
                    this.$refs.grid.excelExport();
                    break;
                case 'clear-filters':
                    this.$refs.grid.clearFiltering();
                    break;
                case "addVisit":
					this.activeModal = this.ActiveModal.AddEdit;
					break;
                case "editVisit":
                    var selectedRecords = this.$refs.grid.getSelectedRecords()
                    if(selectedRecords.length > 1) {
                        this.confirmBoxText = 'More than one record is selected.';
					    this.activeModal = this.ActiveModal.ConfirmBox;
                        break;
                    } else if (selectedRecords.length == 0) {
                        this.confirmBoxText = this.$t('NothingSelected');
                        this.activeModal = this.ActiveModal.ConfirmBox;
                        break;
                    }
                    this.selectedElement = selectedRecords[0]
                    this.activeModal = this.ActiveModal.AddEdit
                    break;
            }
        },
        dataBound() {
            this.$refs.grid.autoFitColumns();
        },
        async handleDownloadReport(visitId, title) {
            try {
                let report = await getReportForFinishedVisit(visitId);
                let blob = new Blob([report], { type: 'application/pdf' });
                let url = window.URL.createObjectURL(blob);

                let fileLink = document.createElement('a');
                fileLink.href = url;
                fileLink.setAttribute('download', `VisitReport_${title}.pdf`);
                document.body.appendChild(fileLink);
                fileLink.click();
                fileLink.remove();

                // window.open(url);
            } catch (error) {
                let errorString = error.response.data;
                if (
                    error.request.responseType === 'blob' &&
                    error.response.data instanceof Blob &&
                    error.response.data.type &&
                    error.response.data.type.toLowerCase().indexOf('json') != -1
                ) {
                    errorString = JSON.parse(await error.response.data.text());
                }

                if(errorString.error == undefined )
                    errorString.error = 'Unexpected error. Check if visit is finished and report was started.'
                
                this.confirmBoxText = this.$t(errorString.error);
                this.activeModal = this.ActiveModal.ConfirmBox
            }
        }
    },
    async mounted() {
        context = this;

        this.ActiveModal = VisitsActiveModal
        this.activeModal = this.ActiveModal.None
        this.getData();
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/Visits/Visits.vue